import styled from "styled-components";

export const CalendarContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	h1 {
		font-family: 'Suit extra bold', 'Inter bold';
		font-size: 20px;
		font-weight: 800;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		margin-bottom: 0px;
	}

  @media screen and (min-width: 300px) and (max-width: 1000px) {
    h1 {
      font-size: 16px;
      line-height: 22px;
      margin-top: 10px;
    }
  }
  
  @media screen and (min-width: 1000px) and (max-width: 1200px) {
    h1 {
      font-size: 16px;
      line-height: 22px;
    }
  }
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    h1 {
      font-size: 24px;
      line-height: 28px;
    }
  }
`;

export const Calendar = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 1);
	border-radius: 10px;
	padding-right: 20px;
	margin-top: 25px;
	box-sizing: border-box;
	display: flex;
  flex-direction: column;
  padding: 35px;
  box-sizing: border-box;
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    padding: 0px;
  }
  @media screen and (min-width: 1000px) and (max-width: 1390px) {
    padding: 20px;
  }
  @media screen and (min-width: 2500px) and (max-width: 3600px) {
    padding: 45px;
  }
`

export const YearMonthWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  margin-bottom: 30px;
  p {
    font-size: 20px;
    color: rgba(38, 38, 38, 1);
    font-family: 'Suit bold', 'Inter bold';
    line-height: 22px;
    font-weight: 700;
  }
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    padding: 10px;
    box-sizing: border-box;
    padding-bottom: 0px;
    p {
      font-size: 16px;
    }
  }
  @media screen and (min-width: 1000px) and (max-width: 1200px) {
    p {
      font-size: 16px;
    }
  }
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    p {
      font-size: 23px;
    }
  }
`;

export const WeekWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background-color: #EEEDF0;
  border: 1px solid #EEEDF0;
  border-radius: 6px 6px 0px 0px;
  height: 33px;
  place-content: center;
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    border-radius: 0px;
  }
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    height: 2vw;
  }
`;

export const DayWrapper = styled.div`
  width: 100%;
  height: 8vw;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-bottom: 1px solid #D7D7D7;
  border-right: 1px solid #D7D7D7;;
`;

export const CalendarItem = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: rgba(38, 38, 38, 1);
  font-family: 'Suit bold', 'Inter bold';
  font-weight: 600;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    font-size: 20px;
  }
`;

export const SiteStatus = styled.div<{status: boolean, completed?: boolean}>`
  border-radius: 5px;
  width: 100%;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props?.completed ? 'rgba(238, 237, 240, 1)' : props.status ? '#F2FFF8': '#FDF1F0'};
  border: 1px solid ${props => props?.completed ? 'rgba(174, 174, 174, 1)' : props.status ? '#00DE66': '#FD3326'};
  color: ${props => props?.completed ? 'rgba(51, 51, 51, 1)' : props.status ? 'rgba(0, 51, 23, 1)' : 'rgba(51, 10, 8, 1)'};
  font-family: 'Suit regular', 'Inter regular';
  font-weight: 400;
  font-size: 10px;
  line-height: 22px;
  @media screen and (min-width: 300px) and (max-width: 450px) {
    font-size: 4.5px;
    height: 12px;
  }
  @media screen and (min-width: 450px) and (max-width: 1460px) {
    font-size: 7px;
    height: 18px;
  }
  @media screen and (min-width: 1920px) and (max-width: 2200px) {
    font-size: 14px;
    width: 100%;
    padding: 5px 4px;
    height: 30px;
  }
  @media screen and (min-width: 2200px) and (max-width: 3500px) {
    font-size: 17px;
    width: 100%;
    padding: 15px 10px;
    height: 35px;
  }
`;

export const OtherStatus = styled.div`
  border-radius: 5px;
  width: 30%;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(215, 214, 217, 1);
  color: rgba(202, 201, 204, 1);
  font-family: 'Suit regular', 'Inter regular';
  font-weight: 400;
  font-size: 10px;
  line-height: 22px;
  color : 'rgba(202, 201, 204, 1)';
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    font-size: 8px;
    height: 15px;
  }
  @media screen and (min-width: 1920px) and (max-width: 2200px) {
    font-size: 14px;
    padding: 5px 4px;
    height: 30px;
  }
  @media screen and (min-width: 2200px) and (max-width: 5000px) {
    font-size: 19px;
    padding: 15px 10px;
    height: 35px;
  }
`;

export const DayGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: 5px;
  border-left: 1px solid #D7D7D7;
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    padding:3px;
  }
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    padding:8px;
  }
`;

export const Day = styled.div<{
  $isSelectedDate?: boolean;
  $isSunday?: boolean;
  $isToday?: boolean;
  $choiceDate?: string | undefined;
  $isMonth?: boolean;
  $isPast?: boolean;
  $isMoreThanTwoWeeksAgo?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 0.8vw;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 5px;
  padding: 0px 7px 7px 7px;
  background-color: ${({$isSelectedDate}) => {
    if($isSelectedDate) return 'rgba(118, 58, 255, 0.1)';
    else return 'transparent'
  }};

  font-weight: ${({ $isSelectedDate }) => ($isSelectedDate ? 700 : 400)};
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(118, 58, 255, 0.05);
  }
  
  span {
    font-family: 'Inter regular';
    font-size: 14px;
    line-height: 22px;
    color: ${({ $isMonth, $isSunday, $isMoreThanTwoWeeksAgo, $isToday }) => {
    if(!$isMonth || !$isMoreThanTwoWeeksAgo) return '#CAC9CC'
    else if ($isSunday) return '#FD3326';
    else if($isToday) return 'white'
    return '#262626';
    }};
    font-weight: ${props => props.$isSelectedDate && props.$isMonth ? 700 : 400};
    text-decoration-line:${props => props.$isSelectedDate && props.$isMonth ? 'underline' : 'none'};
    text-underline-offset : 2px;
    background-color: ${props => props.$isToday ? 'rgb(90, 30, 219)' : 'transparent'};
    border-radius: 50%;
    width: 45px;
    height: 25px;
    display: flex;
    justify-content: ${props => !props.$isToday ? 'flex-start' : 'center'};
    align-items: ${props => !props.$isToday ? 'flex-start' : 'center'};
  }
  
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    column-gap: 0.2vw;
    padding: 0px;
    span {
      font-size: 8px;
      width: 25px;
      height: 15px;
    }
  }
  @media screen and (min-width: 1300px) and (max-width: 1400px) {
    span {
      font-size: 11px;
      width: 25px;
      height: 18px;
    }
  }
  @media screen and (min-width: 1920px) and (max-width: 2200px) {
    padding: 5px 12px 5px 12px;
    column-gap: 0vw;
    span {
      font-size: 16px;
      width: 40px;
      height: 25px;
    }
  }
  @media screen and (min-width: 2200px) and (max-width: 5000px) {
    padding: 5px 12px 5px 12px;
    span {
      font-size: 20px;
      width: 80px;
      height: 42px;
    }
  }
`;

